import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M23.66 6.76a1 1 0 0 0-1-1.26H5.55a.26.26 0 0 1-.25-.2l-.57-2.72A3.26 3.26 0 0 0 1.55 0a1.25 1.25 0 0 0 0 2.5.75.75 0 0 1 .73.59l3.17 15.08a3.25 3.25 0 0 0 1.24 1.93.26.26 0 0 1 .1.19.25.25 0 0 1-.09.2A2 2 0 1 0 10 22a2 2 0 0 0-.21-.89.23.23 0 0 1 0-.24.25.25 0 0 1 .21-.12h6a.25.25 0 0 1 .22.12.25.25 0 0 1 0 .24A1.9 1.9 0 0 0 16 22a2 2 0 0 0 4 0 2 2 0 0 0-.22-.9.3.3 0 0 1 0-.24.25.25 0 0 1 .21-.11 1.25 1.25 0 1 0 0-2.5H8.63a.75.75 0 0 1-.73-.59l-.18-.86a.23.23 0 0 1 0-.21.25.25 0 0 1 .28-.09h10.72a3 3 0 0 0 2.89-2.21Z"
    }, null, -1)
  ]));
}
const shoppingCart = { render };
export {
  shoppingCart as default,
  render
};
//# sourceMappingURL=shopping-cart.svg.js.map
